<template>
	<div class="filtered-search">
		<div id="search">
			<div class="container">
				<div class="content">
					<div class="search-inner">
						<div class="input-wrapper">
							<input type="text" :value="searchQuery" @input="searchQuery=$event.target.value" :placeholder="computedPlaceholder">
							<span @click="erase" v-if="searchQuery.length" id="erase">
								<svg class="navigation-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"/></svg>
							</span>
						</div>
						<!-- <span @click="erase" id="filters">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"/></svg>
						</span> -->
					</div>
				</div>
			</div>
		</div>
		<div id="actions" v-show="selection">
			<div class="container">
				<div class="content">
					<div class="actions-inner">
						<div class="actions actions-left">
							<span @click="clearSelection" class="action"><svg class="link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"></path><path d="M0 0h24v24H0z" style="fill: none;"></path></svg></span>
							<span class="action">
								{{selected.length}}
							</span>
						</div>
						<div class="actions actions-right">
							<span class="action link-icon" @click="clickSelectAll">
								<svg class="link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"/></svg>
							</span>
							<span class="action link-icon" v-if="deleteAction" @click="remove">
								<svg class="link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="list" v-if="loaded">
			<span
				v-for="(item, index) in filteredData"
				:key="'item-' + index"
				:class="[{selected: selected.includes(item)}, 'list-link']"
				@click="clickItem(item, index, $event)"
				v-touch:longtap="longTapItem(item, index)"
			>
				<div class="container">
					<div class="content">
						<div class="list-link-inner">
							<slot name="content" :item="item">
								<div class="list-link-inner-text">
									{{customText(item)}}
									<span class="filtered" v-html="item.text"></span>
								</div>
								<svg class="list-link-icon link-icon arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg>
							</slot>
						</div>
					</div>
				</div>
			</span>
			<span id="no-item-found" v-show="filteredData.length <= 0">{{$t('no-item-found')}}</span>
		</div>
		<div class="list" v-else>
			<span id="no-item-found">{{$t('loading')}}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FilteredSearch',
	props: ['list', 'click', 'customText', 'placeholder','filterAttributes', 'deleteAction', 'loaded'],
	data() {
		return {
			searchQuery: '',
			selected: [],
		}
	},
	computed: {
		itemSelected() {
			return item => this.selected.includes(item);
		},
		allItemsSelected() {
			return this.selected.length == this.filteredData.length;
		},
		computedPlaceholder() {
			if (this.placeholder) return this.placeholder;
			if (this.$t) return this.$t('search');
			return 'Search';
		},
		filteredData() {
			let self = this;
			return [...self.list].filter(o => {
				var searchRegex = new RegExp(self.searchQuery, 'i');
				// return Object.keys(o).some(k => {
				return self.filterAttributes.some(k => {
					if (!self.searchQuery.length) {
						o.text = '';
						return true;
					}
					// if (self.filterAttributes && self.filterAttributes.length && !self.filterAttributes.find(o => o.attribute.includes(k))) {
					// 	return false;
					// }

					// if (!Object.keys(o).find(e => e.includes(k.attribute))) {
					// 	return false;
					// }
					try {
						let value = getProp(o, k.attribute);
						if (value != null && searchRegex.test(value)) {
							let search = self.searchQuery.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
							var re = new RegExp('(' + search.split(' ').join('|') + ')', 'gi');
							o.text = `${k.text}: ${value.toString().replace(re, '<b>$1</b>')}`;
							return true;
						}
					} catch(e) {
					}
					return false;
				});
			});
		},
		selection() {
			return this.selected.length > 0;
		}
	},
	methods: {
		erase() {
			this.searchQuery = '';
		},
		clickItem(item, index, e) {
			let self = this;
			if (self.selection) {
				if (false) { //e && e.shiftKey) {
					// let index = self.filteredData.indexOf(item);
					// if (self.filteredData.indexOf(item))
				} else {
					if (!self.itemSelected(item)) {
						self.selectItem(item);
					} else {
						self.deselectItem(item);
					}
				}
			} else if (e && (e.ctrlKey || e.shiftKey)) {
				this.makeSelection(item, index);
			} else {
				if (self.click) self.click(item, index);
			}
		},
		longTapItem(item, index) {
			let self = this;
			return function(direction, event) {
				self.makeSelection(item, index);
			}
		},
		makeSelection(item, index) {
			let self = this;
			if (!self.selection) {
				self.selectItem(item);
				if (navigator.vibrate){
					navigator.vibrate([100]);
				}
			} else {
				self.clickItem(item, index);
			}
		},
		selectItem(item) {
			this.selected.push(item);
		},
		deselectItem(item) {
			this.selected = this.selected.filter(o => o != item);
		},
		clickSelectAll() {
			if (!this.allItemsSelected) {
				this.selectAll();
			} else {
				this.clearSelection();
			}
		},
		selectAll() {
			let self = this;
			self.filteredData.forEach((item) => {
				if (!self.itemSelected(item)) {
					self.selected.push(item);
				}
			});
		},
		clearSelection() {
			this.selected = [];
		},
		remove() {
			let self = this;
			this.deleteAction(this.selected)
			.then(() => {
				// self.list = self.list.filter(o => !self.selected.includes(o));
			})
			.catch((err) => {

			})
			.then(() => {
				self.clearSelection();
			});
		}
	},
}
</script>


<style scoped>
#search {
	/* background: #aaa; */
	/* border-bottom: .1rem solid #ccc; */
}

#search .search-inner {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1.2rem 0;
}

#search .input-wrapper {
	position: relative;
	width: 100%;
}

#search input {
	margin: 0;
	border: none;
	background: #fff;
	border: .1rem solid #ccc;
	border-radius: 2.8rem;
	height: 2.8rem;
	padding: 0 1.6rem;
}

#search #erase {
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2.8rem;
	height: 2.8rem;
	border-radius: 50%;
	top: 0;
	right: .8rem;
	cursor: pointer;
	/* background: #aaa; */
	/* border: .2rem solid #ccc; */
}

#search #erase:hover,
#search #erase:focus {
	/* background: #999; */
}

#search #erase svg {
	width: 2.4rem;
	height: 2.4rem;
	margin: 0;
}

#search #erase path {
	fill: var(--primary_text_color);
}

#search #erase:hover path,
#search #erase:focus path {
	fill: #000;
}

#search #filters {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2.8rem;
	height: 2.8rem;
	border-radius: 50%;
	cursor: pointer;
/*	background: #ccc;
	border: .2rem solid #ccc;*/
	margin-left: 1.6rem;
}

#search #filters:hover,
#search #filters:focus {
	border-color: #ccc;
	background: #ccc;
}

#search #filters path {
	fill: #fff;
}

#actions {
	position: absolute;
	top: 0;
	width: 100%;
	padding: 1.6rem 0;
	background-color: var(--primary_color);
	color: var(--inverse_text_color);
	font-size: 2.4rem;
	line-height: 4.0rem;
}

#actions .link-icon path {
	fill: var(--inverse_text_color);
}

#actions .actions {
	display: flex;
	align-items: center;
}

#actions .actions-inner {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

#actions .action + .action {
	margin-left: .8rem;
}

#actions .link-icon {
	width: 4.0rem;
	height: 4.0rem;
}

.list .list-link {
	background: #fff;
	cursor: pointer;
	-webkit-tap-highlight-color: rgba(0,0,0,0);
	-webkit-tap-highlight-color: transparent;
	user-select: none;
	-webkit-touch-callout: none;
}

.list .list-link:first-of-type {
	border-top: .1rem solid #d1d1d1;
}

.list.list-link-inner-text {
	display: flex;
	flex-direction: column;
}

.list .list-link.selected {
	background-color: var(--inverse_color);
	color: var(--inverse_text_color);
}

.list .list-link.selected path {
	fill: var(--inverse_text_color);
}

.list #no-item-found {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 8.0vw;
	flex-grow: 1;
	padding-top: 3.2rem;
}

@media screen and (min-width: 400px) {
	.list #no-item-found {
		font-size: 3.6rem;
	}
}
</style>